import React from 'react';
import { SVGProps } from './types';

const ChevronDownIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path stroke="currentColor" strokeMiterlimit="16" d="M4 6l4 4 4-4" />
    </svg>
  );
};

export { ChevronDownIcon };
